export const environment = {
  production: true,
  hmr: false,
  dev: false,
  apiUrl: 'https://t-eduapi.vs.ch/api',
  logoutURL: 'https://t-edu.vs.ch/login',
  keycloakConfig: {
    url: 'https://qas-edusso.tapps.vs.ch/auth/',
    realm: 'ictvs',
    clientId: 'ENT-frontend-t',
  },
  redirectionServiceNow:
    'https://helptest.vs.ch?redirectIdentityProvider=ictvs-oidc',
  supportURL: 'https://support.ictvs.ch/index.php/',
  matomoConfig: {
    url: 'https://analytics-ent.ict-vs.ch/',
    siteId: 2,
    disabled: false,
  },
};
